import { useRef, useState } from 'react';
import { importQuestions } from '../../../api/eliteGameApi';
import ImportQuestion from '../../../component/EliteGame/ImportQuestion';
import { useEliteGames } from '../../../context/EliteGamesContext';
import { ELITE_QUIZ_TYPE } from '../../../utils/constants';
import { errorToast, successToast } from '../../../utils/helper';

const sampleDataByQuizType = {
  QuizZone: {
    headers: [
      { label: 'quiztype', key: 'quiztype' },
      { label: 'category', key: 'category' },
      { label: 'subcategory', key: 'subcategory' },
      { label: 'language', key: 'language' },
      { label: 'question_type', key: 'question_type' },
      { label: 'question', key: 'question' },
      { label: 'option 1', key: 'option1' },
      { label: 'option 2', key: 'option2' },
      { label: 'option 3', key: 'option3' },
      { label: 'option 4', key: 'option4' },
      { label: 'answer', key: 'answer' },
      { label: 'level', key: 'level' },
      { label: 'note', key: 'note' }
    ],
    data: [
      {
        quiztype: '9',
        category: '',
        subcategory: '',
        language: 'english',
        question_type: '{2 if question_type is true false other wise 1}',
        question: 'Sample MCQ Question?',
        option1: 'Answer1',
        option2: 'Answer2',
        option3: 'Answer3',
        option4: 'Answer4',
        answer: 'Answer1',
        level: 1,
        note: 'This is a sample MCQ'
      },
      {
        quiztype: '9',
        category: '',
        subcategory: '',
        language: 'english',
        question_type: '{2 if question_type is true false other wise 1}',
        question: 'Is the sky blue?',
        option1: 'TRUE',
        option2: 'FALSE',
        option3: '{leave this blank cell if question_type is true/false}',
        option4: '{leave this blank cell if question_type is true/false}',
        answer: 'TRUE',
        level: 2,
        note: 'Sample True/False'
      }
    ]
  }
};
const DailyQuizImportQuestion = () => {
  const [refresh, setRefresh] = useState(false);
  const importRef = useRef(); // ✅ ref to trigger child reset

  const { setLoading } = useEliteGames();
  // State to manage quiz type selection
  const [quizType, setQuizType] = useState('QuizZone');
  const onSubmit = async (data) => {
    setLoading(true);
    try {
      // Assuming importQuestions is a function that handles the import logic
      const response = await importQuestions(data, ELITE_QUIZ_TYPE.QUIZ_ZONE);
      successToast('Questions imported successfully!', response.message);
      importRef.current?.reset(); // ✅ reset child input after success
    } catch (error) {
      errorToast('No data to submit', error.message);
    } finally {
      setLoading(false);
    }
    setRefresh(!refresh);
  };
  // Render the ImportQuestion component with the appropriate props
  // Use the sample data based on the selected quiz type
  const { headers, data } = sampleDataByQuizType[quizType];
  return (
    <>
      <ImportQuestion
        ref={importRef}
        onSubmit={onSubmit}
        sampleData={data}
        headers={headers}
        filename={`${quizType.toLowerCase()}-sample.csv`}
      />
    </>
  );
};

export default DailyQuizImportQuestion;
